var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { RotationValue } from '../button-rotation';
import { Styled } from './style';
var ScreenPreview = /** @class */ (function (_super) {
    __extends(ScreenPreview, _super);
    function ScreenPreview(props) {
        var _this = _super.call(this, props) || this;
        _this.getOuterStyle = function () { return ({
            border: '6px solid #000000',
            borderRadius: '3px',
            width: '100%',
        }); };
        _this.getInnerScreenStyle = function () { return ({
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
        }); };
        _this.getScreenStyle = function (width, height) { return ({
            display: 'block',
            background: '#2d3139',
            position: 'relative',
            paddingBottom: 'calc(' + height + '/' + width + '* 100%)',
            width: '100%',
            boxShadow: '0 90px 40px -80px rgba(0,0,0,0.5)',
            overflow: 'hidden',
        }); };
        _this.getContentStyle = function (rotation, width, height) {
            var style = {};
            var w = width;
            var h = height;
            switch (rotation) {
                case RotationValue._0:
                    style = {
                        transform: 'rotate(0deg)',
                        transformOrigin: 'top left',
                        width: '100%',
                        height: '100%',
                        top: '0',
                        left: '0',
                    };
                    break;
                case RotationValue._90:
                    style = {
                        transform: 'rotate(90deg)',
                        transformOrigin: 'top left',
                        width: 'calc(' + h + '/' + w + '* 100%)',
                        height: 'calc(' + w + '/' + h + '* 100%)',
                        top: '0',
                        left: '100%',
                        bottom: 'auto',
                        right: 'auto',
                    };
                    break;
                case RotationValue._180:
                    style = {
                        transform: 'rotate(180deg)',
                        transformOrigin: 'bottom right',
                        width: '100%',
                        height: '100%',
                        top: 'auto',
                        left: 'auto',
                        bottom: '100%',
                        right: '100%',
                    };
                    break;
                case RotationValue._270:
                    style = {
                        transform: 'rotate(270deg)',
                        transformOrigin: 'bottom right',
                        width: 'calc(' + h + '/' + w + '* 100%)',
                        height: 'calc(' + w + '/' + h + '* 100%)',
                        top: 'auto',
                        left: 'auto',
                        bottom: '100%',
                        right: '0',
                    };
                    break;
            }
            return __assign(__assign({}, style), { position: 'absolute' });
        };
        return _this;
    }
    ScreenPreview.prototype.render = function () {
        var _a = this.props, children = _a.children, width = _a.width, height = _a.height, url = _a.url;
        var expectWidth = 800;
        var expectHeight = height / width * expectWidth;
        var expectRotation = this.props.rotation ? this.props.rotation : RotationValue._0;
        var previewClassName = 'rotation-' + expectRotation;
        var screenStyle = this.getScreenStyle(expectWidth, expectHeight);
        var contentStyle = this.getContentStyle(expectRotation, expectWidth, expectHeight); // todo: fix typings
        var innerScreenStyle = this.getInnerScreenStyle();
        var outerStyle = this.getOuterStyle();
        var childrenWrapper = { position: 'relative', width: '100%', height: '100%' };
        var screenOrientation;
        if (width > height) {
            screenOrientation = 'screen-preview-wrapper landscape';
        }
        else {
            innerScreenStyle = __assign(__assign({}, innerScreenStyle), { maxHeight: 'calc(' + height + '/' + width + '* 100%)' });
            screenOrientation = 'screen-preview-wrapper portrait';
        }
        return (React.createElement("div", { className: screenOrientation },
            React.createElement(Styled, { style: outerStyle },
                React.createElement(Styled, { style: screenStyle, className: previewClassName },
                    React.createElement(Styled, { style: innerScreenStyle },
                        React.createElement(Styled, { style: childrenWrapper }, children ? (children) : (React.createElement("iframe", { src: url, scrolling: "yes", frameBorder: "0", style: contentStyle }))))))));
    };
    return ScreenPreview;
}(React.Component));
export default ScreenPreview;
//# sourceMappingURL=index.js.map